module.exports = __webpack_public_path__ + "static/media/folder-light.b4a87676.svg";